import React from "react";
import {
  SiMongodb,
  SiMysql,
  SiReact,
  SiNextdotjs,
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiTailwindcss,
  SiBootstrap
} from "react-icons/si";

const icons = [
  { icon: <span className="text-4xl font-bold">C#</span>, name: "C#" },
  { icon: <SiMongodb size={40} color="#47A248" />, name: "NoSQL (MongoDB)" },
  { icon: <SiMysql size={40} color="#4479A1" />, name: "MySQL" },
  { icon: <SiReact size={40} color="#61DAFB" />, name: "React" },
  { icon: <SiNextdotjs size={40} color="#000000" />, name: "Next.js" },
  { icon: <SiJavascript size={40} color="#F7DF1E" />, name: "JavaScript" },
  { icon: <SiHtml5 size={40} color="#E34F26" />, name: "HTML" },
  { icon: <SiCss3 size={40} color="#1572B6" />, name: "CSS" },
  { icon: <SiTailwindcss size={40} color="#38B2AC" />, name: "Tailwind" },
  { icon: <span className="text-4xl font-bold">B</span>, name: "Blazor" },
  { icon: <SiBootstrap size={40} color="#7952B3" />, name: "Bootstrap" },
];

export default function TechCarousel() {
  return (
    <div className="overflow-hidden w-full max-w-5xl mx-auto">
      <div className="flex animate-scroll space-x-8">
        {icons.concat(icons).map(({ icon, name }, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center min-w-[80px]"
            title={name}
          >
            {icon}
            <span className="text-xs mt-1 text-gray-700 dark:text-gray-500">{name}</span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
      `}</style>
    </div>
  );
}
